import { useList } from "@refinedev/core";
import { cn } from "@/lib/utils";

interface FinancieraPickerProps {
  value: string | null;
  onChange: (id: string) => void;
}

interface Financiera {
  id: string;
  codigo: string;
  nombre: string;
  fee_porcentaje: number;
  color_branding: string | null;
}

export function FinancieraPicker({ value, onChange }: FinancieraPickerProps) {
  const { data, isLoading } = useList<Financiera>({
    resource: "financieras",
    filters: [{ field: "activo", operator: "eq", value: true }],
    pagination: { mode: "off" },
  });

  if (isLoading) return <p className="text-sm text-fg-muted">Cargando...</p>;

  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 gap-2">
      {data?.data.map((f) => (
        <button
          key={f.id}
          type="button"
          onClick={() => onChange(f.id)}
          className={cn(
            "card p-3 text-left transition-all",
            value === f.id
              ? "border-brand ring-2 ring-brand"
              : "hover:border-fg-muted",
          )}
        >
          <p className="font-medium text-sm">{f.nombre}</p>
          <p className="text-xs text-fg-muted">Fee {f.fee_porcentaje}%</p>
        </button>
      ))}
    </div>
  );
}
